"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuItem;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CaretDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/CaretDown"));

var _CaretUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/CaretUp"));

var _ConfigProvider = require("../../../../providers/ConfigProvider");

var _Flex = _interopRequireDefault(require("../../../Flex"));

var _utils = require("../../utils");

var _ClickArea = _interopRequireDefault(require("../ClickArea"));

var _IconWrapper = _interopRequireDefault(require("../IconWrapper"));

var _TextWrapper = _interopRequireDefault(require("../TextWrapper"));

var _SubItemsWrapper = _interopRequireDefault(require("../SubItemsWrapper"));

var _ItemWrapper = _interopRequireDefault(require("../ItemWrapper"));

var _MenuItemWrapper = _interopRequireDefault(require("../MenuItemWrapper"));

var _useMenuItem2 = _interopRequireDefault(require("../hooks/useMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MenuItem(props) {
  var currentPath = props.currentPath,
      navVariant = props.navVariant;

  var _useMenuItem = (0, _useMenuItem2.default)(props),
      expanded = _useMenuItem.expanded,
      item = _useMenuItem.item,
      kind = _useMenuItem.kind,
      toggleExpanded = _useMenuItem.toggleExpanded;

  var disabled = item.disabled,
      text = item.text;

  var _useConfig = (0, _ConfigProvider.useConfig)(),
      LinkComponent = _useConfig.linkRenderer;

  var MenuItemLink = (0, _react.useMemo)(function () {
    return (0, _styledComponents.default)(function (_ref) {
      var active = _ref.active,
          _ = _ref.navVariant,
          linkProps = _objectWithoutProperties(_ref, ["active", "navVariant"]);

      return _react.default.createElement(LinkComponent, linkProps);
    }).withConfig({
      displayName: "NavExpandedItem",
      componentId: "ep2orz-0"
    })([""]);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [LinkComponent]);

  if (kind === 'MenuItemTopLink') {
    var _ref2 = item,
        Icon = _ref2.icon,
        selected = _ref2.active;

    var _to = (0, _utils.isMenuItemInternalLink)(item) ? item.path : item.url;

    var _active = !disabled && (currentPath === _to || selected);

    return _react.default.createElement(_ItemWrapper.default, {
      active: _active,
      disabled: disabled,
      navVariant: navVariant
    }, _react.default.createElement(_ClickArea.default, {
      "aria-disabled": disabled,
      as: disabled ? 'div' : MenuItemLink,
      disabled: disabled,
      navVariant: navVariant,
      tabIndex: disabled ? undefined : 0,
      to: disabled ? undefined : _to
    }, _react.default.createElement(_IconWrapper.default, null, _react.default.createElement(Icon, null)), _react.default.createElement(_TextWrapper.default, null, text)));
  }

  if (kind === 'MenuItemTopLinkWithSubItems') {
    var _ref3 = item,
        _Icon = _ref3.icon,
        items = _ref3.items,
        _selected = _ref3.active;

    var _to2 = (0, _utils.isMenuItemInternalLink)(item) ? item.path : item.url;

    var _active2 = !disabled && (currentPath === _to2 || _selected);

    return _react.default.createElement("li", null, _react.default.createElement(_ItemWrapper.default, {
      as: "div",
      active: _active2,
      disabled: disabled,
      navVariant: navVariant,
      flexDirection: "column"
    }, _react.default.createElement(_Flex.default, {
      flexWrap: "wrap"
    }, _react.default.createElement(_MenuItemWrapper.default, {
      flex: "1 0"
    }, _react.default.createElement(_ClickArea.default, {
      "aria-disabled": disabled,
      as: disabled ? 'div' : MenuItemLink,
      disabled: disabled,
      navVariant: navVariant,
      tabIndex: disabled ? undefined : 0,
      to: disabled ? undefined : _to2
    }, _react.default.createElement(_IconWrapper.default, null, _react.default.createElement(_Icon, null)), _react.default.createElement(_TextWrapper.default, null, text))), _react.default.createElement(_MenuItemWrapper.default, {
      flexDirection: "column"
    }, _react.default.createElement(_ClickArea.default, {
      "aria-disabled": disabled,
      as: "button",
      disabled: disabled,
      flexDirection: "column",
      navVariant: navVariant,
      onClick: toggleExpanded,
      tabIndex: disabled ? undefined : 0,
      variant: "expander"
    }, _react.default.createElement(_Flex.default, {
      paddingX: 1
    }, expanded ? _react.default.createElement(_CaretUp.default, {
      size: "small"
    }) : _react.default.createElement(_CaretDown.default, {
      size: "small"
    })))))), expanded && _react.default.createElement(_SubItemsWrapper.default, {
      navVariant: navVariant
    }, items.map(function (subItem) {
      var key = subItem.text;
      return _react.default.createElement(MenuItem, {
        key: key,
        currentPath: currentPath,
        item: subItem,
        variant: "sub"
      });
    })));
  }

  if (kind === 'MenuItemTopWithSubItems') {
    var _ref4 = item,
        _Icon2 = _ref4.icon,
        _items = _ref4.items;
    return _react.default.createElement("li", null, _react.default.createElement(_ItemWrapper.default, {
      as: "div",
      disabled: disabled,
      navVariant: navVariant,
      flexDirection: "column"
    }, _react.default.createElement(_MenuItemWrapper.default, null, _react.default.createElement(_ClickArea.default, {
      "aria-disabled": disabled,
      as: "button",
      disabled: disabled,
      navVariant: navVariant,
      onClick: toggleExpanded,
      tabIndex: disabled ? undefined : 0
    }, _react.default.createElement(_IconWrapper.default, null, _react.default.createElement(_Icon2, null)), _react.default.createElement(_TextWrapper.default, null, text), _react.default.createElement(_Flex.default, {
      paddingX: 1
    }, expanded ? _react.default.createElement(_CaretUp.default, {
      size: "small"
    }) : _react.default.createElement(_CaretDown.default, {
      size: "small"
    })))), _react.default.createElement(_SubItemsWrapper.default, {
      expanded: expanded,
      navVariant: navVariant
    }, expanded && _items.map(function (subItem) {
      var key = subItem.text;
      return _react.default.createElement(MenuItem, {
        key: key,
        currentPath: currentPath,
        item: subItem,
        variant: "sub"
      });
    }))));
  } // kind === 'MenuSubItem' by default


  var to = (0, _utils.isMenuItemInternalLink)(item) ? item.path : item.url;
  var active = !disabled && (currentPath === to || item.active);
  return _react.default.createElement(_ItemWrapper.default, {
    active: active,
    disabled: disabled,
    navVariant: navVariant
  }, _react.default.createElement(_ClickArea.default, {
    "aria-disabled": disabled,
    as: disabled ? 'div' : MenuItemLink,
    disabled: disabled,
    navVariant: navVariant,
    tabIndex: disabled ? undefined : 0,
    to: disabled ? undefined : to,
    variant: "sub"
  }, _react.default.createElement(_TextWrapper.default, null, text)));
}